import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d321a8ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "게시물 등록", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "p-fluid formgrid grid" }
const _hoisted_7 = { class: "field col-12 md:col-4" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "gateType" }, "게이트", -1))
const _hoisted_9 = { class: "field col-12 md:col-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "worksType" }, "동작방식", -1))
const _hoisted_11 = { class: "field col-12 md:col-4" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "mediaType" }, "미디어", -1))
const _hoisted_13 = { class: "field col-12" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "title" }, "제목", -1))
const _hoisted_15 = { class: "field col-12" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "videoUrl" }, "Youtube 동영상 URL", -1))
const _hoisted_17 = {
  key: 0,
  class: "field col-12"
}
const _hoisted_18 = { style: {"display":"flex","width":"960px","height":"720px","vertical-align":"middle","align-items":"center"} }
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src", "alt"]
const _hoisted_21 = { class: "grid grid-nogutter justify-content-center" }
const _hoisted_22 = ["src", "alt"]
const _hoisted_23 = { style: {"margin-bottom":".5rem"} }
const _hoisted_24 = {
  key: 1,
  class: "field col-5"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pi pi-trash p-button-icon p-button-icon-right" }, null, -1))
const _hoisted_26 = { class: "p-button-label" }
const _hoisted_27 = { class: "field col-12" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "image" }, "사진 업로드(최대 10MB)", -1))
const _hoisted_29 = { class: "field col-12 md:col-4" }
const _hoisted_30 = { class: "p-buttonset" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirmation-content" }, [
  /*#__PURE__*/_createElementVNode("span", null, "게시물을 삭제하시겠습니까?")
], -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "confirmation-content" }, [
  /*#__PURE__*/_createElementVNode("span", null, "사진을 삭제하시겠습니까?")
], -1))


import { reactive } from "vue";
import axios from "axios";
import { useCookies } from "vue3-cookies";

const { cookies } = useCookies();

const __default__ = {
  data() {
    return {
      search                   : reactive({
        codeGroupId: ""
      }),
      gateGallery              : ({
        gateGalleryId: this.$route.params.galleryId,
        galleryTitle : "",
        gateTypeCd   : "",
        gateWorksCd  : "",
        mediaTypeCd  : "",
        videoUrl     : "",
        fileNames    : []
      }),
      images                   : [],
      gateGalleryItemId        : "",
      isVideoMedia             : false,
      gateCategory             : [],
      worksCategory            : [],
      mediaCategory            : [],
      isEditMode               : this.$route.params.galleryId !== undefined,
      displayDialog            : false,
      displayItemDialog        : false,
      galleriaResponsiveOptions: [
        {
          breakpoint: "1024px",
          numVisible: 5
        }
      ]
    };
  },
  async mounted() {
    await this.init();
    this.loading = false;
  },
  methods: {
    init                        : async function() {
      this.resetGallery();
      await this.getGateCategory();
      await this.getMediaCategory();
      if (this.$route.params.galleryId !== undefined) {
        await this.getGateGallery();
      }
      await this.displayImageGallery();
    },
    resetGallery                : function() {
      this.gateGallery = ({
        gateGalleryId: this.$route.params.galleryId,
        galleryTitle : "",
        gateTypeCd   : "",
        gateWorksCd  : "",
        mediaTypeCd  : "",
        thumbFilePath: "",
        videoUrl     : "",
        fileNames    : []
      });
    },
    getGateGallery              : async function() {
      const _this = this;
      await axios.post("/api/gate-gallery/get", this.gateGallery, {
        headers: { "Authorization": `Bearer ${cookies.get("Authentication")}` }
      }).then(function(response) {
        if (response.data.success === 200 && response.data.resp) {
          _this.gateGallery.gateGalleryId = response.data.resp.gateGalleryId;
          _this.gateGallery.galleryTitle = response.data.resp.galleryTitle;
          _this.gateGallery.gateTypeCd = response.data.resp.gateTypeCd;
          _this.gateGallery.gateWorksCd = response.data.resp.gateWorksCd;
          _this.gateGallery.mediaTypeCd = response.data.resp.mediaTypeCd;
          _this.gateGallery.videoUrl = response.data.resp.videoUrl;
          _this.changeGateCategory();
          _this.showVideoUrl();
        }
      }).catch(function(err) {
        console.error(err);
        _this.showToast("error", "서버 접속 실패", "관리자에게 문의해주세요.");
      });
    },
    getGateCategory             : async function() {
      this.search.codeGroupId = "GTTYPE";
      this.gateCategory = await this.getCodeDetailViewArr();
    },
    getMediaCategory            : async function() {
      this.search.codeGroupId = "MDTYPE";
      this.mediaCategory = await this.getCodeDetailViewArr();
    },
    getGateWorksCategory        : async function() {
      this.setWorksTypeCodeGrpId(this.gateGallery.gateTypeCd);
      this.worksCategory = await this.getCodeDetailViewArr();
    },
    setWorksTypeCodeGrpId       : function(codeFullCd) {
      if (codeFullCd === "GTTYPE1000") {
        this.search.codeGroupId = "GWT100";
      } else if (codeFullCd === "GTTYPE2000") {
        this.search.codeGroupId = "GWT200";
      }
    },
    getCodeDetailViewArr        : async function() {
      const _this = this;
      let returnData = null;
      await axios.post("/api/comm/getCodeDetailViewArr", this.search, {
        headers: { "Authorization": `Bearer ${cookies.get("Authentication")}` }
      }).then(function(response) {
        if (response.data.success === 200) {
          returnData = response.data.resp.codeDetailViewArr;
        }
      }).catch(function(err) {
        console.error(err);
        _this.showToast("error", "서버 접속 실패", "관리자에게 문의해주세요.");
      });

      return returnData;
    },
    showVideoUrl                : function() {
      this.isVideoMedia = this.gateGallery.mediaTypeCd === "MDTYPE2000";
    },
    changeGateCategory          : function() {
      this.getGateWorksCategory();
    },
    changeMediaCategory         : function() {
      this.showVideoUrl();
    },
    postGateGallery             : async function() {
      if (!this.validateForm()) return;
      // 에디터 모드면서 파일이 없는 경우 정보만 업데이트
      if (this.isEditMode && this.$refs.fileUploadRef.files[0] === undefined) {
        this.callbackPostGateGallery();
      } else {
        this.isVideoMedia ? this.$refs.videoFileUploadRef.upload() : this.$refs.fileUploadRef.upload();
      }
    },
    validateForm                : function() {
      let failMessage = "";

      if (!this.isEditMode) {
        if (!this.validateFileUpload()) {
          failMessage = "사진을 업로드 해주세요";
        }
        if (this.isVideoMedia
          && this.$refs.videoFileUploadRef.files[0] !== undefined
          && this.$refs.videoFileUploadRef.files.length > 1) {
          failMessage = "동영상은 한 개의 사진만 업로드 할 수 있습니다.";
        }
      }

      if (this.isEditMode) {
        if (this.images.length === 0
          && !this.validateFileUpload()) {
          failMessage = "사진을 업로드 해주세요";
        }
      }

      if (this.gateGallery.mediaTypeCd === "MDTYPE2000") {
        if (this.gateGallery.videoUrl === "") {
          failMessage = "동영상 URL을 입력해주세요.";
        } else if (!this.validateUrl(this.gateGallery.videoUrl)) {
          failMessage = "올바른 동영상 URL 형식을 입력해주세요.";
        }
      }
      if (this.gateGallery.galleryTitle === "")
        failMessage = "제목을 입력해주세요.";
      if (this.gateGallery.mediaTypeCd === "")
        failMessage = "미디어를 선택해주세요.";
      if (this.gateGallery.gateWorksCd === "")
        failMessage = "동작방식을 선택해주세요.";
      if (this.gateGallery.gateTypeCd === "")
        failMessage = "게이트를 선택해주세요.";
      if (failMessage !== "") {
        this.showToast("warn", "업로드 실패", failMessage);
        return false;
      }

      return true;
    },
    validateFileUpload          : function() {
      if (this.$refs.fileUploadRef.files[0] === undefined
        && this.$refs.videoFileUploadRef.files[0] === undefined) {
        return false;
      }
      return true;
    },
    validateUrl                 : function(url) {
      const regex = RegExp("(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+@]*)*(\\?[;&a-z\\d%_.~+=-@]*)?(\\#[-a-z\\d_@]*)?$", "i");
      return url.match(regex);
    },
    callSingleUploadGalleryImage: async function(event) {
      await this.uploadGalleryImage(event.files[0]);
      this.callbackPostGateGallery();
    },
    callMultiUploadGalleryImage : async function(event) {
      const fileList = event.files;
      const _this = this;
      for (let i = 0; i < fileList.length; i++) {
        await _this.uploadGalleryImage(fileList[i]);
      }
      this.callbackPostGateGallery();
    },
    uploadGalleryImage          : async function(fileObj) {
      const imageFile = await this.castingImageFile(fileObj.objectURL, fileObj.name);
      const formData = new FormData();
      formData.append("imageFile", imageFile, imageFile.name);
      const _this = this;
      return await axios.post("/api/gate-gallery/uploadGalleryImage", formData, {
        headers: {
          "Content-Type" : "multipart/form-data",
          "Authorization": `Bearer ${cookies.get("Authentication")}`
        }
      }).then(function(response) {
        if (response.data.success === 200) {
          _this.pushFileNames(response.data.resp.fileName);
        }
      }).catch(function(err) {
        console.error(err);
        _this.showToast("error", "업로드 실패", "사진 업로드에 실패하였습니다.\n관리자에게 문의해주세요.");
        return false;
      });
    },
    callbackPostGateGallery     : function() {
      const _this = this;
      axios.post("/api/gate-gallery/post", this.gateGallery, {
        headers: { "Authorization": `Bearer ${cookies.get("Authentication")}` }
      }).then(function(response) {
        if (response.data.success === 200) {
          alert(`게시물을 ${_this.isEditMode ? "수정" : "등록"}했습니다.`);
          _this.$router.push({ name: "GateGallery" });
        }
      }).catch(function(err) {
        console.error(err);
        _this.showToast("error", "등록 실패", "게시물 등록에 실패했습니다.\n관리자에게 문의 바랍니다.");
      });
    },
    castingImageFile            : async function(blobUrl, fileName) {
      return await fetch(blobUrl).then(r => r.blob()).then(blobFile => new File([blobFile], fileName, { type: "image/*" }));
    },
    showToast                   : function(toastType, message, description) {
      this.$toast.add({ severity: toastType, summary: message, detail: description, life: 3000 });
    },
    historyBack                 : function() {
      this.$router.push({ name: "GateGallery" });
    },
    openDeleteDialog            : function() {
      this.displayDialog = true;
    },
    openDeleteItemDialog        : function(event) {
      if (this.images.length === 1) {
        this.showToast("error", "삭제 불가", "최소 한장의 사진이 필요합니다.");
        return;
      }
      this.gateGalleryItemId = event.target.id;
      this.displayItemDialog = true;
    },
    closeDialog                 : function() {
      this.displayDialog = false;
    },
    closeItemDialog             : function() {
      this.displayItemDialog = false;
    },
    deleteGateGallery           : function() {
      const _this = this;
      axios.post("/api/gate-gallery/delete", this.gateGallery, {
        headers: { "Authorization": `Bearer ${cookies.get("Authentication")}` }
      }).then(function(response) {
        if (response.data.success === 200) {
          alert("삭제되었습니다.");
          _this.$router.push({ name: "GateGallery" });
        }
      }).catch(function(err) {
        console.error(err);
        _this.showToast("error", "삭제 실패", "게시물 삭제에 실패했습니다.\n관리자에게 문의 바랍니다.");
      });
    },
    pushFileNames               : function(fileName) {
      this.gateGallery.fileNames.push(fileName);
    },
    displayImageGallery         : async function() {
      const _this = this;
      await axios.post("/api/gate-gallery-item/list", { "gateGalleryId": this.gateGallery.gateGalleryId }, {
        headers: { "Authorization": `Bearer ${cookies.get("Authentication")}` }
      }).then(function(response) {
        if (response.data.success === 200) {
          _this.images = response.data.resp;
        }
      }).catch(function(err) {
        console.error(err);
        _this.showToast("error", "조회 실패", "게시물 조회에 실패했습니다.\n관리자에게 문의 바랍니다.");
      });
    },
    deleteGateGalleryItem       : function() {
      const _this = this;
      axios.post("/api/gate-gallery-item/delete", { "id": this.gateGalleryItemId }, {
        headers: { "Authorization": `Bearer ${cookies.get("Authentication")}` }
      }).then(function(response) {
        if (response.data.success === 200) {
          _this.showToast("success", "삭제 완료", "사진이 삭제되었습니다.");
          _this.closeItemDialog();
          _this.init();
        }
      }).catch(function(err) {
        console.error(err);
        _this.showToast("error", "삭제 실패", "사진 삭제에 실패했습니다.\n관리자에게 문의 바랍니다.");
      });
    }
  }
};
import img_blank from "@/assets/images/pages/img_blank02.png";
import "@/assets/styles/badges.scss";
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {


return (_ctx, _cache) => {
  const _component_Toast = _resolveComponent("Toast")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Textarea = _resolveComponent("Textarea")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Galleria = _resolveComponent("Galleria")
  const _component_Button = _resolveComponent("Button")
  const _component_FileUpload = _resolveComponent("FileUpload")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createVNode(_component_Toast, { position: "top-center" }),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createVNode(_component_Dropdown, {
              id: "gateType",
              modelValue: _ctx.gateGallery.gateTypeCd,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.gateGallery.gateTypeCd) = $event)),
              options: _ctx.gateCategory,
              optionLabel: "name",
              optionValue: "code",
              placeholder: "선택",
              onChange: _ctx.changeGateCategory
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_Dropdown, {
              id: "worksType",
              modelValue: _ctx.gateGallery.gateWorksCd,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.gateGallery.gateWorksCd) = $event)),
              options: _ctx.worksCategory,
              optionLabel: "name",
              optionValue: "code",
              placeholder: "선택"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createVNode(_component_Dropdown, {
              id: "mediaType",
              modelValue: _ctx.gateGallery.mediaTypeCd,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.gateGallery.mediaTypeCd) = $event)),
              options: _ctx.mediaCategory,
              optionLabel: "name",
              optionValue: "code",
              placeholder: "선택",
              onChange: _ctx.changeMediaCategory
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createVNode(_component_Textarea, {
              id: "title",
              rows: "3",
              modelValue: _ctx.gateGallery.galleryTitle,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.gateGallery.galleryTitle) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_15, [
            _hoisted_16,
            _createVNode(_component_InputText, {
              id: "videoUrl",
              modelValue: _ctx.gateGallery.videoUrl,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.gateGallery.videoUrl) = $event)),
              type: "text"
            }, null, 8, ["modelValue"])
          ], 512), [
            [_vShow, _ctx.isVideoMedia]
          ]),
          (_ctx.isEditMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createVNode(_component_Galleria, {
                  value: _ctx.images,
                  responsiveOptions: _ctx.galleriaResponsiveOptions,
                  numVisible: 5,
                  showItemNavigatorsOnHover: true,
                  showItemNavigators: true,
                  circular: true,
                  containerStyle: "max-width: 70%"
                }, {
                  item: _withCtx(({item}) => [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("img", {
                        src: _unref(img_blank),
                        alt: "화면비율유지",
                        style: {"display":"none","min-height":"500px"}
                      }, null, 8, _hoisted_19),
                      _createElementVNode("img", {
                        src: item.originFilePath,
                        alt: item.fileName,
                        style: {"margin":"0 auto","display":"block","max-width":"100%","max-height":"100%","min-height":"500px"}
                      }, null, 8, _hoisted_20)
                    ])
                  ]),
                  thumbnail: _withCtx(({item}) => [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("img", {
                        src: item.thumbFilePath,
                        alt: item.fileName,
                        style: {"display":"block","width":"100%","max-height":"170px"}
                      }, null, 8, _hoisted_22)
                    ])
                  ]),
                  caption: _withCtx(({item}) => [
                    _createElementVNode("h4", _hoisted_23, _toDisplayString(item.fileName), 1)
                  ]),
                  _: 1
                }, 8, ["value", "responsiveOptions"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isEditMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (item) => {
                  return (_openBlock(), _createBlock(_component_Button, {
                    key: item.id,
                    class: "p-button p-component p-button-raised p-button-text p-button-plain",
                    type: "button",
                    onClick: _ctx.openDeleteItemDialog,
                    id: item.id
                  }, {
                    default: _withCtx(() => [
                      _hoisted_25,
                      _createElementVNode("span", _hoisted_26, _toDisplayString(item.fileName), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick", "id"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _withDirectives(_createVNode(_component_FileUpload, {
              name: "image",
              onUploader: _ctx.callMultiUploadGalleryImage,
              multiple: true,
              customUpload: true,
              accept: "image/*",
              chooseLabel: "사진 선택",
              showUploadButton: false,
              showCancelButton: false,
              maxFileSize: 10000000,
              previewWidth: 110,
              fileLimit: 10,
              ref: "fileUploadRef",
              invalidFileSizeMessage: "사진의 크기는 10MB를 넘을 수 없습니다.",
              invalidFileTypeMessage: "사진만 업로드 할 수 있습니다.",
              invalidFileLimitMessage: "최대 10개의 사진까지 업로드 할 수 있습니다."
            }, null, 8, ["onUploader"]), [
              [_vShow, !_ctx.isVideoMedia]
            ]),
            _withDirectives(_createVNode(_component_FileUpload, {
              name: "image",
              onUploader: _ctx.callSingleUploadGalleryImage,
              multiple: true,
              customUpload: true,
              accept: "image/*",
              chooseLabel: "사진 선택",
              showUploadButton: false,
              showCancelButton: false,
              maxFileSize: 10000000,
              previewWidth: 110,
              fileLimit: 1,
              ref: "videoFileUploadRef",
              invalidFileSizeMessage: "사진의 크기는 10MB를 넘을 수 없습니다.",
              invalidFileTypeMessage: "사진만 업로드 할 수 있습니다.",
              invalidFileLimitMessage: "동영상은 한 개의 사진만 업로드 할 수 있습니다."
            }, null, 8, ["onUploader"]), [
              [_vShow, _ctx.isVideoMedia]
            ])
          ], 512), [
            [_vShow, _ctx.gateGallery.mediaTypeCd !== '']
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("span", _hoisted_30, [
              (!_ctx.isEditMode)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 0,
                    class: "p-button p-component p-button-info",
                    onClick: _ctx.postGateGallery,
                    label: "등록",
                    icon: "pi pi-check"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isEditMode)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 1,
                    class: "p-button p-component p-button-info",
                    onClick: _ctx.postGateGallery,
                    label: "수정",
                    icon: "pi pi-check"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.isEditMode)
                ? (_openBlock(), _createBlock(_component_Button, {
                    key: 2,
                    class: "p-button p-component p-button-danger",
                    onClick: _ctx.openDeleteDialog,
                    label: "삭제",
                    icon: "pi pi-trash"
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true),
              _createVNode(_component_Button, {
                class: "p-button p-component p-button-secondary",
                onClick: _ctx.historyBack,
                label: "취소",
                icon: "pi pi-times"
              }, null, 8, ["onClick"])
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_Dialog, {
      header: "Delete",
      visible: _ctx.displayDialog,
      "onUpdate:visible": _cache[5] || (_cache[5] = $event => (_isRef(displayDialog) ? (displayDialog).value = $event : null)),
      style: {width: '380px'},
      modal: true,
      closable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "네",
          icon: "pi pi-check",
          onClick: _ctx.deleteGateGallery,
          class: "p-button-text",
          autofocus: ""
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "아니오",
          icon: "pi pi-times",
          onClick: _ctx.closeDialog,
          class: "p-button-text"
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _hoisted_31
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_Dialog, {
      header: "Delete",
      visible: _ctx.displayItemDialog,
      "onUpdate:visible": _cache[6] || (_cache[6] = $event => (_isRef(displayItemDialog) ? (displayItemDialog).value = $event : null)),
      style: {width: '380px'},
      modal: true,
      closable: false
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "네",
          icon: "pi pi-check",
          onClick: _ctx.deleteGateGalleryItem,
          class: "p-button-text",
          autofocus: ""
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "아니오",
          icon: "pi pi-times",
          onClick: _ctx.closeItemDialog,
          class: "p-button-text"
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _hoisted_32
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})